'use client'
import type { FieldValues, UseFormRegister } from 'react-hook-form'
import { useFormContext } from 'react-hook-form'
import React, { useEffect } from 'react'
import { usePathname } from 'next/navigation'

export const SentFromPath: React.FC<{
  register: UseFormRegister<FieldValues>
}> = ({ register }) => {
  const props = register('sentFromPath')
  const { setValue } = useFormContext()
  const pathname = usePathname()

  useEffect(() => {
    setValue(props.name, pathname)
  }, [pathname])

  return <React.Fragment></React.Fragment>
}
